module.exports = __webpack_public_path__ + "static/img/indexText3.5c6f2d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/indexText3.png
// module id = h1IY
// module chunks = 1